import * as ajax from "../../../actions/ajaxCounterActions";
import * as exception from "../../../actions/exceptionActions";

import financieelApi from "../../../api/financieelApi";

import { getStore } from "../../../store/configureStore";
import * as constants from "../../../constants/DomainConstants";
import showToastr from "../../../util/toastr.js";
import redirector from '../../../util/redirector';

export default class InvesteringEditPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		this.context.setState({
			investering: null,
			modalIsOpen: false
		});

		const dossierId = this.context.props.params.dossierId;
		const investeringId = this.context.props.params.investeringId;

		if (investeringId) {
			this.getInvestering(investeringId);
			this.context.setState({ dossierId: dossierId, investeringId: investeringId });
		}
		else {
			this.getEmptyInvestering(dossierId);
			this.context.setState({ dossierId: dossierId });
		}
	}

	loadLayout() {
		this.context.props.loadLayout();
	}

	loadBeads(beadModels) {
		this.context.props.beadsLoaded(beadModels);
	}

	change(event) {
		let field = event.target.name;
		let value = event.target.value;

		field = field.indexOf("btwPercentage") > -1 ? "btwPercentage" : field;
		field = field.indexOf("btwAftrekbaar") > -1 ? "btwAftrekbaar" : field;

		let investering = this.context.state.model;

		investering[field] = value;

		let btwInclusief = 0.0;
		let btwValue = 0;
		let bedragExclusiefBTW = 0;

		field == "bedragExclusiefBTW"
			? bedragExclusiefBTW = parseFloat(value)
			: bedragExclusiefBTW = parseFloat(investering.bedragExclusiefBTW);

		field == "btwPercentage"
			? btwValue = parseInt(value)
			: btwValue = parseInt(investering.btwPercentage);

		field == "verkregenSubsidieZelfdeWerken"
			? isNaN(parseFloat(value)) ? value = 0 : value = parseFloat(value)
			: null;

		btwInclusief = bedragExclusiefBTW + (bedragExclusiefBTW * (btwValue > 0 ? (btwValue / 100) : 0));
		btwInclusief = Math.round(btwInclusief * 100) / 100;

		if(investering.subsidiesToegekend == "false" || investering.subsidiesToegekend === false)
		{
			investering = Object.assign({}, investering, { "verkregenSubsidieZelfdeWerken": 0  });
		}

		let totaal = 0;
		if (investering.type != 121450000) {
			totaal = 0;
		} else if (investering.subsidiesToegekend == "true" || investering.subsidiesToegekend === true) {
			totaal = 0;
		} else if (investering.hoofdcategorie == constants.NIET_VERANKERBAAR_SPORTMATERIAAL && investering.typeDossier !== constants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_RENOVATIE) {
			totaal = 0;
		} else {
			if (investering.btwAftrekbaar == "true" || investering.btwAftrekbaar === true) {
				totaal = bedragExclusiefBTW - investering.verkregenSubsidieZelfdeWerken;
			} else {
				totaal = btwInclusief - investering.verkregenSubsidieZelfdeWerken;
			}
		}

		this.context.setState({
			model: Object.assign({}, investering, { [field]: value, "bedragInclusiefBTW": isNaN(btwInclusief) ? 0 : btwInclusief, "totaalSubsidieerbaarBedrag": isNaN(totaal) ? 0 : totaal }),
			hasUnsavedChanges: true
		});
	}

	getInvestering(investeringId) {
		this.dispatch(ajax.started());
		financieelApi.getInvestering(investeringId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				this.loadLayout(response.data.item);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	getEmptyInvestering(dossierId) {
		this.dispatch(ajax.started());
		financieelApi.getEmptyInvestering(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				this.loadLayout(response.data.item);

				if(response.data.infrastructuren.length === 0)
				{
					this.context.setState({
						modalIsOpen: true
					});
				}
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	save() {
		this.dispatch(ajax.started());
		financieelApi.saveInvestering(this.context.state.model)
			.then((response) => {
				this.dispatch(ajax.ended());
				let result = null;
				if (response.data.concurrencyException) {
					this.setStateAfterUpdate(response.data.item, response.data.validationResults);
					result = constants.HAS_CONCURRENCY_EXCEPTION;
				} else if (response.data.hasValidationErrors) {
					this.setStateAfterUpdate(response.data.item, response.data.validationResults);
					result = constants.HAS_VALIDATION_ERRORS;
				} else if (Object.keys(response.data.validationResults).length !== 0) {
					this.setStateAfterUpdate(response.data.item, response.data.validationResults);
					result = constants.HAS_VALIDATION_ERRORS_SAVED;
				} else {
					this.setStateAfterUpdate(response.data.item, {}, false);
					result = constants.SUCCESS;
				}
				let isSaved = showToastr(result);
				if (isSaved) {
					this.context.setState({ hasUnsavedChanges: false });
					if (result === constants.SUCCESS)
						this.goToOverview();
				}
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	goToOverview() {
		const state = this.context.state;
		const hasUnsavedChanges = state.hasUnsavedChanges;

		if (hasUnsavedChanges)
			window.parent.scrollTo(0, 350);
		redirector.goTo(`/financieel/${state.dossierId}/investeringen`);
	}

	setStateAfterUpdate(model, validationMessages, hasUnsavedChanges) {
		this.context.setState({
			model: model,
			validationMessages: validationMessages,
			hasUnsavedChanges: hasUnsavedChanges == undefined ? this.context.state.hasUnsavedChanges : hasUnsavedChanges
		});
	}

	isReadyToRender() {
		if (!this.context.state.model) {
			return false;
		}

		return true;
	}

	goToProjectAdres()
	{
		this.redirector.goTo(`/project/${this.context.state.dossierId}#adres`);
		this.context.setState({
			modalIsOpen: false
		});
	}
}